<script setup>
import {onMounted, onUnmounted, ref} from "vue";
import moment from "moment/moment";
import forestreeHelpers from "@/helpers/forestreeHelpers";
import AssignWork from "@/components/AssignWork.vue";

const props = defineProps({
    tree: {},
    index: {},
    hideThings: {},
    users: {},
    access: {},
    permissions: {},
    teams: {}
})
const emit = defineEmits(['removeFlag'])

const editFlag = ref(false)
const flaggedItemRef = ref(null)

function close(e) {
    if (!flaggedItemRef.value.contains(e.target)) {
        editFlag.value = false;
    }
}

function removeFlag(flagId) {
    emit('removeFlag', flagId);
}

function dueDate(date, duration) {
    if (moment(date).isValid()) {
        return moment(date).add(duration, 'weeks').format("DD/MM/YYYY");
    } else {
        return "-";
    }
}

onMounted(() => {
    document.addEventListener('click', close)
})

onUnmounted(() => {
    document.removeEventListener('click', close)
})
</script>


<template>
    <div class="tr" ref="flaggedItemRef">
        <div class="td py-2 border-b border-slate-200 w-1/2 lg:w-1/6 items-center">
            <a :href="tree.type === 'planting' ? '/vacant-map?showFlagged=true&treeId='+tree.tree_id+'&lng='+tree.tree.lng+'&lat='+tree.tree.lat : '/map?showFlagged=true&treeId='+tree.tree_id"
               class="text-slate-600 py-2 font-bold mr-3">
                #{{ tree.tree_id }}
                <span v-if="tree.tree.trees_risk_id === 1"
                      class="bg-green-200 text-green-500 text-xs rounded-full px-3 py-1">Low</span>
                <span v-if="tree.tree.trees_risk_id === 2"
                      class="bg-orange-200 text-orange-500 text-xs rounded-full px-3 py-1">Moderate</span>
                <span v-if="tree.tree.trees_risk_id === 3"
                      class="bg-red-200 text-red-500 text-xs rounded-full px-3 py-1">High</span>
                <span v-if="tree.tree.trees_risk_id === 4"
                      class="bg-red-300 text-red-800 text-xs rounded-full px-3 py-1">Extreme</span>
            </a>
        </div>
        <div class="td py-2 border-b border-slate-200 w-1/2 lg:w-1/6 items-center">
            <span v-if="tree.tree.address" class="py-2 mr-2 text-slate-500 text-sm">{{
                    tree.tree.address.length < 40 ? tree.tree.address : tree.tree.address.substring(0, 40) + ".."
                }}</span>
        </div>
        <div :class="hideThings ? 'w-1/2 lg:w-2/6' : 'w-1/2 lg:w-1/6'"
             class="td py-2 border-b border-slate-200 items-center">
            {{ tree.notes }}
        </div>
        <assign-work
            v-if="!hideThings && (tree.type === 'inspection' || tree.type === 'planting')"
            class="w-1/2 lg:w-1/6 border-b border-slate-200"
            :work="{id:tree.tree_id, assignments: tree.assignments}"
            :users="users"
            :teams="teams"
            assignTypeId="1"
            :permissions="permissions"
        />
        <assign-work
            v-if="!hideThings && tree.type === 'review'"
            class="w-1/2 lg:w-1/6 border-b border-slate-200"
            :work="{id:tree.tree_id, assignments: tree.review_assignments}"
            :users="users"
            :teams="teams"
            assignTypeId="13"
            :permissions="permissions"
        />
        <div class="td py-2 border-b border-slate-200 text-slate-500 w-1/2 lg:w-1/6 items-center">
            {{ tree.reported_by.name }}
            <br>
            {{ forestreeHelpers.dateTime(tree.created_at) }}
        </div>
        <div class="td py-2 border-b border-slate-200 text-slate-500 w-1/2 lg:w-1/6 items-center flex justify-between">
            <span v-if="tree.next_inspection" class="w-1/2">{{ dueDate(tree.created_at, tree.duration) }}</span>
            <span v-else class="w-1/2">{{ dueDate(tree.created_at, tree.duration) }}</span>
            <div class="w-1/2 flex justify-end">
                <button v-if="permissions && !permissions.contractor" @click="editFlag = !editFlag"
                        class="group relative ml-2 w-8 h-8 bg-white rounded-full inline-flex items-center justify-center focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                        id="options-menu-0" aria-haspopup="true" aria-expanded="false">
          <span class="flex items-center justify-center h-full w-full rounded-full">
            <svg class="w-5 h-5 text-slate-400 group-hover:text-slate-500" xmlns="http://www.w3.org/2000/svg"
                 viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
              <path d="M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z"/>
            </svg>
          </span>
                </button>
                <div v-if="editFlag" class="relative" style="right:0">
                    <div
                        class="origin-top-right absolute z-10 w-48 rounded-lg shadow-lg bg-white ring-1 ring-black ring-opacity-5"
                        style="top: 0.6rem;right: 2.2rem;"
                        aria-label="options-menu">
                        <div class="py-1" role="menu" aria-orientation="vertical" aria-labelledby="options-menu-0">
                            <div @click="removeFlag(tree.id)"
                                 class="block px-4 py-2 text-sm text-slate-700 hover:bg-slate-100 hover:text-slate-900 cursor-pointer"
                                 role="menuitem">Remove Flag
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


